import { useContext } from 'react';
import { doc, setDoc, query, where, getDocs, collectionGroup, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { FB_COLLECTION_PATH } from '../functions/postActionTypes';
import { ProfileContext } from '../context/ProfileContext';

export const useMessageRead = () => {
  const { profile } = useContext(ProfileContext);

  const markChatAsRead = async (chatId: string, chatType: string): Promise<void> => {
    try {
      // Update chat document
      const chatDocRef = doc(db, FB_COLLECTION_PATH.Chats, profile.UserId);
      await setDoc(
        chatDocRef,
        {
          [chatId]: {
            isRead: true,
          },
        },
        { merge: true }
      );

      // If it's a job message, also update the job doc
      if (chatType === "JobMsg") {
        await markJobMessageAsRead(chatId);
        await markJobMessageAsReadFeed(chatId);
      }
    } catch (error) {
      console.error("Error marking chat as read:", error);
    }
  };

  const markJobMessageAsRead = async (jobId: string): Promise<void> => {
    const jobDocQuery = query(
      collectionGroup(db, "jobsDocs"),
      where("jobInfo.core.uniqueJobId", "==", jobId),
      where("docStamp.userInfoTo.uid", "==", profile.UserId)
    );

    try {
      const querySnapshot = await getDocs(jobDocQuery);
      querySnapshot.forEach(async (docSnap) => {
        const jobDocRef = doc(db, FB_COLLECTION_PATH.JobsDocs, docSnap.id);
        await updateDoc(jobDocRef, {
          "jobInfo.status.isNewMessage": false,
        });
      });
    } catch (error) {
      console.error("Error marking job message as read:", error);
    }
  };

  const markJobMessageAsReadFeed = async (jobId: string): Promise<void> => {
    // const jobDocQuery = query(
    //   collectionGroup(db, "jobFeed"),
    //   where("jobId", "==", jobId),
    //   where("werkerJobDocId", "==", )
    // );

    const docRef = doc(db, FB_COLLECTION_PATH.Users, profile.UserId, FB_COLLECTION_PATH.JobFeed, jobId);

    
    try {
      // const querySnapshot = await getDocs(jobDocQuery);
      const snap = await getDoc(docRef);

      if (snap.exists()) {
        // console.log(snap.data());
        await updateDoc(docRef, {
          "isNewMessage": false,
        });
      }


      // querySnapshot.forEach(async (docSnap) => {
      //   const jobDocRef = doc(db, "jobsDocs", docSnap.id);
      //   await updateDoc(jobDocRef, {
      //     "jobInfo.status.isNewMessage": false,
      //   });
      // });
    } catch (error) {
      console.error("Error marking job message as read:", error);
    }
  };

  return {
    markChatAsRead
  };
};